import * as React from "react";
import { useState } from "react";
import { useTranslation } from "react-i18next";
import { useNavigate, useLocation } from "react-router-dom";
import { Search } from "lucide-react";
import { Button } from "@/components/ui/button";
import { cn } from "@/lib/utils";

export function HeaderSearch() {
  const { t } = useTranslation(["catalog", "common"]);
  const navigate = useNavigate();
  const location = useLocation();
  const [value, setValue] = useState("");

  React.useEffect(() => {
    const params = new URLSearchParams(location.search);
    const searchParam = params.get("q") || params.get("search") || "";
    setValue(searchParam);
  }, []);

  function handleSubmit(e: React.FormEvent) {
    e.preventDefault();
    const trimmed = value.trim();
    const params = new URLSearchParams(location.search);

    if (trimmed) {
      params.set("q", trimmed);
    } else {
      params.delete("q");
    }

    navigate(`/catalog?${params.toString()}`);
  }

  return (
    <form
      onSubmit={handleSubmit}
      className={cn(
        "hidden md:flex items-center gap-2 rounded-full bg-muted/60 px-3 py-1",
        "border border-muted-foreground/10 hover:bg-muted transition"
      )}
    >
      <Search className="h-4 w-4 text-muted-foreground" />
      <input
        type="search"
        className="bg-transparent border-none outline-none text-xs w-32 lg:w-48 placeholder:text-muted-foreground/80"
        value={value}
        onChange={(e) => setValue(e.target.value)}
        placeholder={t("catalog:searchPlaceholder", "Search products...")}
      />
      <Button
        type="submit"
        size="icon"
        variant="ghost"
        className="h-7 w-7 rounded-full"
      >
        <Search className="h-3 w-3" />
        <span className="sr-only">
          {t("catalog:search.button", "Search")}
        </span>
      </Button>
    </form>
  );
}
